import React, { Component } from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import RaisedButton from "material-ui/RaisedButton";
import FlatButton from "material-ui/FlatButton";
import facebookSVG from "images/facebook.svg";

export const PrimaryButton = props => {
  return <RaisedButton {...props} backgroundColor="#E57B41" labelColor="#FFFFFF" />;
};

export const FacebookButton = props => {
  return (
    <FlatButton
      icon={
        <div
          style={{
            backgroundImage: `url(${facebookSVG})`,
            backgroundSize: "contain",
            width: 20,
            height: 20,
            display: "inline-block",
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat"
          }}
        />
      }
      href="https://www.facebook.com/thepocketmod"
      target="_blank"
      style={{ minWidth: 40, marginTop: 5 }}
      {...props}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/ui/Buttons.js